import { useElapsed } from "../../utils/useElapsed";

import { useOverlayOrchestrator } from "./createOverlayOrchestratorContext";
import type { OverlayType } from "./createOverlayOrchestratorContext";

type OverlayStep = Exclude<OverlayType, "consent">;

type OverlayStepConfig = {
  previousStep: OverlayType;
  /**
   * Optional interactions to perform before proceeding to the next step.
   * Interactions is applied only if the previous step is completed.
   */
  interactions?: {
    delay?: number; // seconds
  };
};

/**
 * Mapping of overlay steps to their orchestration counterparts.
 * This is used to determine the next step in the overlay flow.
 */
const OVERLAY_STEP_ORCHESTRATION: Record<OverlayStep, OverlayStepConfig> = {
  "custom-banner": { previousStep: "consent" },
  "adjust-banner": { previousStep: "custom-banner" },
  "google-one-tap": {
    previousStep: "custom-banner",
    interactions: { delay: 5 },
  },
  airship: { previousStep: "google-one-tap" },
  qualtrics: { previousStep: "google-one-tap" },
};

export const useOverlayStepsOrchestrator = (key: OverlayStep) => {
  const { state } = useOverlayOrchestrator();
  const { previousStep, interactions } = OVERLAY_STEP_ORCHESTRATION[key];
  const previousStepState = state[previousStep];
  const delay = interactions?.delay;

  const isElapsed = useElapsed({
    duration: delay ?? 0,
    active: previousStepState === "completed" && !!delay,
  });

  return (
    previousStepState === "disabled" ||
    (previousStepState === "completed" && (isElapsed || !delay))
  );
};
